import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import 'react';

const SmallEdit = ({ testId, className, solid })=>{
    return /*#__PURE__*/ jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: solid ? /*#__PURE__*/ jsxs(Fragment, {
            children: [
                /*#__PURE__*/ jsxs("g", {
                    clipPath: "url(#clip0_4792_838)",
                    children: [
                        /*#__PURE__*/ jsx("path", {
                            d: "M1 13H12.9792",
                            stroke: "currentColor",
                            strokeWidth: "1.4",
                            strokeLinecap: "round"
                        }),
                        /*#__PURE__*/ jsx("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M8.26996 0.918832C9.32279 -0.135821 11.0298 -0.135818 12.0826 0.918833C13.1354 1.97349 13.1354 3.68341 12.0826 4.73807L6.02173 10.8094C5.90651 10.9248 5.75469 10.9963 5.59246 11.0116L2.47685 11.3042C2.2695 11.3236 2.06428 11.2495 1.91702 11.102C1.76976 10.9545 1.69578 10.7489 1.71522 10.5412L2.00731 7.42021C2.02252 7.2577 2.09389 7.10561 2.20911 6.9902L8.26996 0.918832Z",
                            fill: "currentColor"
                        })
                    ]
                }),
                /*#__PURE__*/ jsx("defs", {
                    children: /*#__PURE__*/ jsx("clipPath", {
                        id: "clip0_4792_838",
                        children: /*#__PURE__*/ jsx("rect", {
                            width: "14",
                            height: "14",
                            fill: "white"
                        })
                    })
                })
            ]
        }) : /*#__PURE__*/ jsxs(Fragment, {
            children: [
                /*#__PURE__*/ jsxs("g", {
                    clipPath: "url(#clip0_4520_4919)",
                    children: [
                        /*#__PURE__*/ jsx("path", {
                            d: "M1 13H12.9792",
                            stroke: "currentColor",
                            strokeWidth: "1.4",
                            strokeLinecap: "round"
                        }),
                        /*#__PURE__*/ jsx("path", {
                            d: "M8.76475 1.41421C9.54445 0.633163 10.8086 0.633165 11.5883 1.41421V1.41421C12.368 2.19526 12.368 3.46159 11.5883 4.24264L5.52743 10.314L2.41181 10.6066L2.7039 7.48558L8.76475 1.41421Z",
                            stroke: "currentColor",
                            strokeWidth: "1.4",
                            strokeLinejoin: "round"
                        })
                    ]
                }),
                /*#__PURE__*/ jsx("defs", {
                    children: /*#__PURE__*/ jsx("clipPath", {
                        id: "clip0_4520_4919",
                        children: /*#__PURE__*/ jsx("rect", {
                            width: "14",
                            height: "14",
                            fill: "white"
                        })
                    })
                })
            ]
        })
    });
};

export { SmallEdit as default };
